import { Plugins } from "@/src/shared/types/plugins";
import { ref, Ref } from "vue";

export class EasyPluginsStore {
  private static instance: EasyPluginsStore = new EasyPluginsStore();
  private activatedPlugins: Ref<Plugins[]> = ref([]);

  private constructor() {}

  static getInstance(): EasyPluginsStore {
    return EasyPluginsStore.instance;
  }

  public init(activatedPlugins: Plugins[]) {
    this.activatedPlugins.value = activatedPlugins;
  }

  public isPluginActivated(key: Plugins): boolean {
    return this.activatedPlugins.value.includes(key);
  }

  public get plugins(): Plugins[] {
    return [...this.activatedPlugins.value];
  }
}

export default EasyPluginsStore.getInstance();
